import React, { useState } from 'react';
import { Button } from '../ui/button';
import { AlertTriangle, Loader2, Check } from 'lucide-react';
import { authAPI } from '../../services/api';
import { toast } from 'sonner';

const EmailVerificationBanner = () => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleResendVerification = async () => {
    setSending(true);
    try {
      const res = await authAPI.resendVerification();
      setSent(true);
      toast.success(res.data.message || 'Verification email sent. Check your inbox');
      // Reset sent state after 60 seconds
      setTimeout(() => setSent(false), 60000);
    } catch (error) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      
      if (status === 429) {
        toast.error(detail || 'Please wait before requesting another email');
      } else if (status === 503) {
        // Email quota exceeded
        toast.error(detail || 'Email service temporarily unavailable. Please try again later.');
      } else {
        toast.error(detail || 'Failed to send verification email. Please try again later.');
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <div 
      className="bg-amber-500/20 border-b border-amber-500/30 px-4 py-3"
      data-testid="email-verification-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
          <p className="text-amber-900 dark:text-amber-100 text-sm">
            <span className="font-semibold">Your email address isn't verified yet.</span>{' '}
            <span className="opacity-90">Some features are limited until you verify.</span>
          </p>
        </div>
        <button
          onClick={handleResendVerification}
          disabled={sending || sent}
          className={`text-sm font-medium transition-colors ${
            sent 
              ? 'text-green-600 dark:text-green-400 cursor-default flex items-center gap-1' 
              : 'text-amber-700 dark:text-amber-200 hover:text-amber-900 dark:hover:text-white underline underline-offset-2'
          }`}
          data-testid="resend-verification-btn"
        >
          {sending ? (
            <>
              <Loader2 className="w-3 h-3 animate-spin inline mr-1" />
              Sending...
            </>
          ) : sent ? (
            <>
              <Check className="w-4 h-4" />
              Verification email sent
            </>
          ) : (
            'Resend verification email'
          )}
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
